/* Publish by EComposer at 2026-10-13 07:06:56*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-4zpe1b6xr86"]=  window.__ectimmers["ecom-4zpe1b6xr86"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-4zpe1b6xr86').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4zpe1b6xr86', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3223si7v6k2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3223si7v6k2', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-eh7sr5vvxzi"]=  window.__ectimmers["ecom-eh7sr5vvxzi"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-eh7sr5vvxzi"]["edd8sxuxk"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-eh7sr5vvxzi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eh7sr5vvxzi', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5al2e0srwe4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5al2e0srwe4', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gxwavo0vx7m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gxwavo0vx7m', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4xx38oojbj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4xx38oojbj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sdvj2fiban').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sdvj2fiban', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ve6k3olswfh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ve6k3olswfh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zpzqa3y7wa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zpzqa3y7wa', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vegb5n5gbo9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vegb5n5gbo9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5ghhjlpseo6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5ghhjlpseo6', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9ni9mqx26d5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9ni9mqx26d5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0zq0chvx188m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0zq0chvx188m', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5aco6ai9yxv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5aco6ai9yxv', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2o75xshylnx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2o75xshylnx', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-04v66opoym62').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-04v66opoym62', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rgqfjil19b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rgqfjil19b', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9vzur76leeg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9vzur76leeg', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vkn4xpfxm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vkn4xpfxm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7n3bq6vr7zi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7n3bq6vr7zi', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dyd9ff4it8m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dyd9ff4it8m', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1flr7fupnbd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1flr7fupnbd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zb2qjczubx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zb2qjczubx', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8pugyh336g8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8pugyh336g8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-onq5gqih95').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-onq5gqih95', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p2zu9epwyi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p2zu9epwyi', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q0xuz4bv6wk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q0xuz4bv6wk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-32m34ejzzd3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-32m34ejzzd3', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mfkz2wyvgka').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mfkz2wyvgka', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q47lf6tbhrq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q47lf6tbhrq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ia4s5z2p0jm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ia4s5z2p0jm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-53pml77ausn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-53pml77ausn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pm805jj619d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pm805jj619d', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8c0kmj6afqw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8c0kmj6afqw', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sd4g9cl3z5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sd4g9cl3z5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qmxvome248g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qmxvome248g', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cf8o03k3df7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cf8o03k3df7', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cbglbwy1xs7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cbglbwy1xs7', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tb65rv4xiw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tb65rv4xiw', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-svo6u0o6ibr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-svo6u0o6ibr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lwa5d39z3nl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lwa5d39z3nl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a7zl5slmve').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a7zl5slmve', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-36x70usjsjd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-36x70usjsjd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dn5bqg0p3t9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dn5bqg0p3t9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rpcn9lx1qo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rpcn9lx1qo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gy75m2p0vk7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gy75m2p0vk7', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3je7np49mm7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3je7np49mm7', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cqfz9sr7wse').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cqfz9sr7wse', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-egexojoiuua').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-egexojoiuua', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-khlz93iqcsj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-khlz93iqcsj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-12uc4xek4sli').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-12uc4xek4sli', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l5u8wksuo08').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l5u8wksuo08', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zaamgkta2d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zaamgkta2d', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-0owyn3fo6kph"]=  window.__ectimmers["ecom-0owyn3fo6kph"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-0owyn3fo6kph"]["yul2pxdbr"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-0owyn3fo6kph').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0owyn3fo6kph', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-86w8edkw0cn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-86w8edkw0cn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vbjaofp392').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vbjaofp392', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zka3lixpp3a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zka3lixpp3a', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0uz3tci5zfa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0uz3tci5zfa', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6mqbimo9zhw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6mqbimo9zhw', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8bm9e8c7h0o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8bm9e8c7h0o', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0mdkdwihxgnn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0mdkdwihxgnn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jlj9a0n1ryd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jlj9a0n1ryd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rwrl4gbu3e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rwrl4gbu3e', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tlfrduvf62m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tlfrduvf62m', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o5o1i1thry').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o5o1i1thry', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uozsn0s2jt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uozsn0s2jt', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zqwu6dlpi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zqwu6dlpi', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t64nr12ge4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t64nr12ge4', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oem588mmhsn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oem588mmhsn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dgmp8hs6psj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dgmp8hs6psj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mccitj1e7ea').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mccitj1e7ea', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l4j8zij1m8p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l4j8zij1m8p', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wzqth0t6bzf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wzqth0t6bzf', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}